import(/* webpackMode: "eager" */ "/home/runner/work/cc-provider/cc-provider/src/app/global-error.tsx");
